import React, { useEffect, useRef } from "react";

const AddressAutocomplete = ({ onSelect, placeholder = "Enter address" }) => {
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);

  useEffect(() => {
    if (!window.google || !inputRef.current) return;

    autocompleteRef.current = new window.google.maps.places.Autocomplete(
      inputRef.current,
      { types: ["address"] } // restricts to addresses only
    );

    autocompleteRef.current.setFields([
      "address_components",
      "formatted_address",
    ]);

    autocompleteRef.current.addListener("place_changed", () => {
      const place = autocompleteRef.current.getPlace();

      if (!place.address_components) return;

      const address = {
        full: place.formatted_address,
        street: "",
        route: "",
        city: "",
        state: "",
        zip: "",
        country: "",
      };

      place.address_components.forEach((comp) => {
        const types = comp.types;
        if (types.includes("street_number"))
          address.street = comp.long_name + " " + address.street;
        if (types.includes("route")) address.route += comp.long_name;
        if (types.includes("locality")) address.city = comp.long_name;
        if (types.includes("administrative_area_level_1"))
          address.state = comp.long_name;
        if (types.includes("postal_code")) address.zip = comp.long_name;
        if (types.includes("country")) address.country = comp.long_name;
      });

      onSelect(address);
    });
  }, []);

  return (
    <textarea
      ref={inputRef}
      type="text"
      rows="3"
      placeholder={placeholder}
      className="w-full border p-2 rounded-md shadow-sm"
    />
  );
};

export default AddressAutocomplete;

// import React, { useState, useEffect } from "react";

// const AddressInput = ({ label, onSelect }) => {
//   const [query, setQuery] = useState("");
//   const [suggestions, setSuggestions] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [showDropdown, setShowDropdown] = useState(false);

//   useEffect(() => {
//     if (!query) {
//       setSuggestions([]);
//       setShowDropdown(false);
//       return;
//     }

//     setLoading(true);
//     const delayDebounce = setTimeout(() => {
//       fetch(
//         `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(
//           query
//         )}&format=json&addressdetails=1&limit=5`
//       )
//         .then((res) => res.json())
//         .then((data) => {
//           setSuggestions(data);
//           setShowDropdown(true);
//           setLoading(false);
//         })
//         .catch(() => {
//           setSuggestions([]);
//           setShowDropdown(false);
//           setLoading(false);
//         });
//     }, 500);

//     return () => clearTimeout(delayDebounce);
//   }, [query]);

//   const handleSelect = (place) => {
//     setQuery(place.display_name);
//     setSuggestions([]);
//     setShowDropdown(false);
//     if (onSelect) onSelect(place);
//   };

//   return (
//     <div className="w-full max-w-md relative">
//       {label && <label className="block mb-1 font-medium">{label}</label>}
//       <input
//         type="text"
//         value={query}
//         onChange={(e) => setQuery(e.target.value)}
//         placeholder="Enter address"
//         className="w-full border rounded px-3 py-2"
//         onFocus={() => query && setShowDropdown(true)}
//       />

//       {loading && <p className="text-sm text-gray-500">Loading...</p>}

//       {showDropdown && suggestions.length > 0 && (
//         <ul
//           className="absolute left-0 right-0 border rounded mt-1 bg-white shadow-md max-h-40 overflow-y-auto
//           transition-all duration-200 ease-in-out transform scale-100 origin-top"
//         >
//           {suggestions.map((place) => (
//             <li
//               key={place.place_id}
//               onClick={() => handleSelect(place)}
//               className="px-3 py-2 cursor-pointer hover:bg-gray-100"
//             >
//               {place.display_name}
//             </li>
//           ))}
//         </ul>
//       )}
//     </div>
//   );
// };

// export default AddressInput;
